import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../contexts/LanguageContext";
import { t, tr } from "../i18n/translations";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const { lang } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") {
      navigate("/admin", { replace: true });
    }
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F0EC] px-6">
      <div className="w-full max-w-md bg-[#FAFAFA] p-10 border border-[#E8E1DA]" data-testid="admin-login">
        <Link to="/" className="overline text-[#8B6D5E]">← Abril Suarez</Link>
        <h1 className="font-serif text-4xl tracking-tight mt-6 mb-8">{tr(t.admin.login_title, lang)}</h1>
        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="field-label">{tr(t.admin.email, lang)}</label>
            <input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="field"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="field-label">{tr(t.admin.password, lang)}</label>
            <input
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="field"
              data-testid="admin-login-password"
            />
          </div>
          <button disabled={loading} type="submit" className="btn-primary w-full justify-center" data-testid="admin-login-submit">
            {loading ? "…" : tr(t.admin.login, lang)}
          </button>
        </form>
      </div>
    </div>
  );
}
